import { useEffect } from 'react';

import { LocalizationProvider } from '@mui/lab';
import AdapterMoment from '@mui/lab/AdapterMoment';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { SnackbarProvider } from 'notistack';
import { I18nextProvider } from 'react-i18next';

import { setDateFnsLocale } from './date-fns-locale';
import useI18Next from './hooks/useI18Next';
import Loading from './pages/Loading';
import { MsTeamsProvider } from './providers/MsTeamsProvider';
import Routes from './Routes';

const queryClient = new QueryClient();

const App = () => {
    const { loading, error, i18n } = useI18Next();

    useEffect(() => {
        if (i18n?.languages) {
            setDateFnsLocale(i18n.languages[0]);
        }
    }, [i18n.languages]);

    if (loading) {
        return <Loading />;
    }

    if (error) {
        // eslint-disable-next-line
        return <div>Error</div>;
    }

    return (
        <QueryClientProvider client={queryClient}>
            <LocalizationProvider dateAdapter={AdapterMoment}>
                <I18nextProvider i18n={i18n}>
                    <MsTeamsProvider>
                        <SnackbarProvider anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}>
                            <Routes />
                        </SnackbarProvider>
                    </MsTeamsProvider>
                </I18nextProvider>
            </LocalizationProvider>
        </QueryClientProvider>
    );
};

export default App;
